import * as React from 'react';
import { CSSObject } from 'styled-components';
import { config, animated, useSpring, SpringConfig } from 'react-spring';

type Props = {
  children: React.ReactElement;
  show?: boolean;
  config?: SpringConfig;
  delay?: number;
  immediate?: boolean;
  reverse?: boolean;
  style?: CSSObject;
};

const FadeIn: React.FC<Props> = ({
  children,
  config: springConfig = config.default,
  delay = 0,
  immediate = false,
  reverse = false,
  show = true,
  style,
}) => {
  const props = useSpring({
    from: { opacity: 0 },
    opacity: show ? 1 : 0,
    config: springConfig,
    delay,
    immediate,
    reverse,
  });

  return (
    <>
      <animated.div style={{ ...props, ...style }}>{children}</animated.div>
    </>
  );
};

export default FadeIn;
